// Angular
import { Injectable } from '@angular/core';

// Libraries
import { BehaviorSubject } from 'rxjs';

// Models
import { AppCleanup } from '../../../models';

@Injectable({
	providedIn: 'root',
})
export class SpinnerService extends AppCleanup {
	showAppSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	showContentSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {
		super();
	}

	showAppSpinner() {
		this.showAppSpinner$.next(true);
	}

	hideAppSpinner() {
		this.showAppSpinner$.next(false);
	}

	showContentSpinner() {
		this.showContentSpinner$.next(true);
	}

	hideContentSpinner() {
		this.showContentSpinner$.next(false);
	}
}
